import UserBankDataCollapsible from './UserBankDataCollapsible';
export { UserBankDataCollapsible };